const openAccordion = (el) => el.classList.add('is_active');
const closeAccordion = (el) => el.classList.remove('is_active');

const initAccordion = () => {
  const accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach((accordion) => {
    const trigger = accordion.querySelector('[data-accordion-trigger]');

    trigger.addEventListener('click', (e) => {
      if (accordion.classList.contains('is_active')) {
        closeAccordion(accordion);
        return;
      }

      accordions.forEach((accordion) => closeAccordion(accordion));
      openAccordion(accordion);
    });
  });

  openAccordion(accordions[0]);
};

export default initAccordion;
